import type { GetQuoteResponse } from '@taxfyle/api-internal/internal/draft_pb'
import { safeDecimalToNumber } from '@/utils/grpc-util'
import type { Quote } from './Quote'

/**
 * Maps a GetQuoteResponse proto to a Quote.
 *
 * @param proto GetQuoteResponse proto to map
 */
export function mapGetQuoteResponseToQuote(proto: GetQuoteResponse): Quote {
  const coupon = proto.getCoupon()

  return {
    items: proto.getJobScopeItemNamesList().map((name) => ({ name })),
    price: {
      primaryAmount: safeDecimalToNumber(proto.getPrimaryAmount()),
      upfrontAmount: safeDecimalToNumber(proto.getAmountDueNow()),
      total: safeDecimalToNumber(proto.getTotal()),
      discount: coupon
        ? {
            couponId: coupon.getId(),
            couponCode: coupon.getCode(),
            amount: safeDecimalToNumber(coupon.getAmount()),
          }
        : null,
    },
  }
}
